import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import blueGrey from '@material-ui/core/colors/blueGrey';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { push } from 'connected-react-router';
import { ICareerInfo } from 'src/actions/search';
import SearchScenarioFactory from 'src/scenario/SearchScenarioFactory';
import { IMessage } from '../actions/message';
import * as Actions from '../actions/questionnaire';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ELearningScenarioFactory, {
	IFetchELearningProgressParam,
	IFetchELearningTreeParam,
} from '../scenario/ELearningScenarioFactory';
import ScenarioFactory, {
	IFetchQuestionnaireParam,
	ISaveQuestionnaireParam,
	IUpdateQuestionnaireParam,
} from '../scenario/QuestionnaireScenarioFactory';
import FormControl from '../utils/FormControlWrapper';
import ReplaceStyleKeywords from '../utils/ReplaceStyleKeywords';
import { Routes, Screens } from '../utils/Routes';
import { funcClose } from '../utils/StartupUtils';
import { IQuestionnaireProps } from './ELearningQuestionnaire';

const styles = (theme: Theme) =>
	createStyles({
		blockTitle: {
			flexGrow: 1,
			fontSize: '1.2rem',
		},
		mustFlg: {
			color: '#FF0000',
			fontWeight: 'bold',
		},
		paper: {
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
			padding: theme.spacing(3),
		},
		questionnaire: {
			borderColor: blueGrey[100],
			borderRadius: '1em',
			borderStyle: 'solid',
			marginTop: theme.spacing(2),
			padding: theme.spacing(2),
		},
		questionnaireTitle: {
			fontSize: '1rem',
			marginBottom: theme.spacing(2),
		},
		root: {
			padding: theme.spacing(2),
			wordBreak: 'break-word',
		},
		table: {
			padding: theme.spacing(1),
		},
		textArea: {
			width: '100%',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			wordBreak: 'break-word',
		},
		width: {
			width: '100%',
		},
	});

interface IState {
	answers: { [questionnaireID: string]: number | number[] | string };
	disableReportButton: boolean;
	saveResultSnackbar: boolean;
	openReportConfirm: boolean;
	openErrorMessageDialog: boolean;
	openReportResult: boolean;
	previewDisplayTmpSaveBtn: boolean;
	selectedBlock: number;
	selectedQuestionnaire: number;
	messages: IMessage[];
	careerName: string;
	vendor: string;
}

/**
 * アンケートウィザード形式
 */
class QuestionnaireWizard extends React.Component<IProps, IState> {
	protected preBtnDisabled: boolean;
	protected nextBtnDisabled: boolean;

	constructor(props: IProps) {
		super(props);

		this.state = {
			answers: {},
			careerName: '',
			disableReportButton: false,
			messages: [],
			openErrorMessageDialog: false,
			openReportConfirm: false,
			openReportResult: false,
			previewDisplayTmpSaveBtn: true,
			saveResultSnackbar: false,
			selectedBlock: 0,
			selectedQuestionnaire: 0,
			vendor: '',
		};
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillReceiveProps(nextProps: IProps) {
		if (this.props.blocks === nextProps.blocks) {
			return;
		}

		const selectedQuestionnaireEnd = nextProps.selectedQuestionnaire;
		if (selectedQuestionnaireEnd === 0) {
			this.setState({ selectedQuestionnaire: selectedQuestionnaireEnd });
		}

		// 回答データの初期化
		// サーバからのデータに回答が入っていた場合は反映する
		const answers = {};
		for (const block of nextProps.blocks) {
			for (const q of block.questionnaires) {
				switch (q.questionnaireType) {
					case Actions.QuestionnaireType.SELECT:
					case Actions.QuestionnaireType.RADIO_BUTTON:
						answers[q.questionnaireID] = q.selectedReply;
						break;
					case Actions.QuestionnaireType.CHECK_BOX:
						answers[q.questionnaireID] = [];
						for (const o of q.options as Actions.IOption[]) {
							if (o.selected) {
								answers[q.questionnaireID].push(o.replyOrder);
							}
						}
						break;
					case Actions.QuestionnaireType.TEXT_AREA:
						if (q.options && q.options.length) {
							answers[q.questionnaireID] = q.options[0].replyText;
						}
						break;
				}
			}
		}

		this.setState({
			answers,
		});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		if (this.props.accessFlg === 1) {
			this.props.onRef(this);
		}
		this.fetch();
		if (this.props.assessmentFlg) {
			this.props
				.doFetchCareerDetail(this.props.token, this.props.careerID)
				.then(data => {
					const careerInfo: ICareerInfo = data.careerInfo;
					this.setState({
						careerName: careerInfo.careerTitle || '',
						vendor: careerInfo.vendor || '',
					});
				});
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.careerID === this.props.careerID &&
			prevProps.classID === this.props.classID &&
			prevProps.id === this.props.id
		) {
			return;
		}
		// アンケートから違うアンケートに遷移したときここにくる
		this.setState({
			selectedBlock: 0,
			selectedQuestionnaire: 0,
		});
		this.fetch();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearQuestionnaireParams();
	}

	public render() {
		if (this.props.blocks.length === 0) {
			return <div />;
		}

		const { classes } = this.props;
		const block = this.props.blocks[this.state.selectedBlock];
		const questionnaire =
			block.questionnaires[this.state.selectedQuestionnaire];
		const { selectedBlock, selectedQuestionnaire } = this.state;
		const disablePrev = selectedBlock === 0 && selectedQuestionnaire === 0;
		const disableNext =
			selectedBlock === this.props.blocks.length - 1 &&
			selectedQuestionnaire === block.questionnaires.length - 1;
		this.preBtnDisabled = disablePrev;
		this.nextBtnDisabled = disableNext;
		if (this.props.accessFlg === 1) {
			this.props.updateState();
		}
		const flg =
			this.props.scoreItemsRegisterFlag === '1' &&
			this.props.respondentCategoryFlg === '1';
		return (
			<div className={this.props.classes.root}>
				<Typography variant="h6" gutterBottom={true}>
					{this.props.assessmentFlg
						? this.state.careerName
						: this.props.enqueteName}
				</Typography>
				{this.props.assessmentFlg && this.state.vendor && (
					<Typography variant="h6" align={'center'}>
						{i18n.t('QuestionnaireWizard_0001', {
							vendor: this.state.vendor,
						})}
					</Typography>
				)}
				<div className={classes.root}>
					<Grid container={true} spacing={1}>
						<Grid item={true} xs={3}>
							<Paper className={this.props.classes.table}>
								{this.renderTable()}
							</Paper>
						</Grid>
						<Grid item={true} xs={9}>
							<Paper className={classes.paper}>
								<Typography
									variant="h6"
									className={classes.blockTitle}
									gutterBottom={true}
								>
									{!this.props.assessmentFlg &&
										block.blockName}
									{this.props.assessmentFlg &&
										(flg
											? block.blockName
											: this.state.careerName)}
								</Typography>
								{this.renderQuestionnaire(questionnaire)}
							</Paper>
							{this.props.accessFlg === 0 && (
								<Grid
									container={true}
									spacing={3}
									justify="space-between"
								>
									<Grid item={true}>
										<Fab
											color="primary"
											aria-label="right"
											onClick={this.handlePrev}
											disabled={disablePrev}
										>
											<ArrowBackIcon />
										</Fab>
									</Grid>
									<Grid item={true}>
										<Fab
											color="primary"
											aria-label="left"
											onClick={this.handleNext}
											disabled={disableNext}
										>
											<ArrowForwardIcon />
										</Fab>
									</Grid>
								</Grid>
							)}
							{this.props.periodJudgment !== 2 && (
								<this.Buttons />
							)}
						</Grid>
					</Grid>
				</div>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('QuestionnaireWizard_0002')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}

	/*
	 * テーブル描画
	 */
	protected renderTable() {
		const { blocks } = this.props;
		const { selectedBlock, selectedQuestionnaire } = this.state;

		return blocks.map((block, i) => {
			let activeStep = -1;
			if (i < selectedBlock) {
				activeStep = block.questionnaires.length;
			} else if (i === selectedBlock) {
				activeStep = selectedQuestionnaire;
			}
			return (
				<div key={i}>
					<Typography variant="h6">{block.blockName}</Typography>
					<Stepper activeStep={activeStep} orientation="vertical">
						{block.questionnaires.map(q => {
							return (
								<Step key={q.questionnaireID}>
									<StepLabel>
										<Hidden xsDown={true}>
											{q.questionnaireNo}
										</Hidden>
									</StepLabel>
								</Step>
							);
						})}
					</Stepper>
				</div>
			);
		});
	}

	/**
	 * 質問描画
	 * @param questionnaire 質問情報
	 */
	protected renderQuestionnaire(questionnaire: Actions.IQuestionnaire) {
		const { classes } = this.props;

		let answerForm: JSX.Element | null = null;
		switch (questionnaire.questionnaireType) {
			case Actions.QuestionnaireType.SELECT:
				answerForm = this.questionnaireSelect(questionnaire);
				break;
			case Actions.QuestionnaireType.RADIO_BUTTON:
				answerForm = this.questionnaireRadio(questionnaire);
				break;
			case Actions.QuestionnaireType.CHECK_BOX:
				answerForm = this.questionnaireCheck(questionnaire);
				break;
			case Actions.QuestionnaireType.TEXT_AREA:
				answerForm = this.questionnaireText(questionnaire);
				break;
		}

		return (
			<div className={classes.questionnaire}>
				<Typography variant="h6" className={classes.questionnaireTitle}>
					{questionnaire.mustFlg === 1 && (
						<span className={classes.mustFlg}>＊</span>
					)}
					{questionnaire.questionnaireNo}{' '}
					<span
						dangerouslySetInnerHTML={{
							__html: ReplaceStyleKeywords.replaceStyleKeywords(
								questionnaire.questionnaireText
							),
						}}
					/>
				</Typography>
				{answerForm}
			</div>
		);
	}

	/**
	 * 選択コンポーネント
	 * @param questionnaire 質問情報
	 */
	protected questionnaireSelect(questionnaire: Actions.IQuestionnaire) {
		const options = questionnaire.options as Actions.IOption[];
		const qid = questionnaire.questionnaireID;
		const value = (this.state.answers[qid] as number) || -1;
		return (
			<form autoComplete="off">
				<FormControl className={this.props.classes.width}>
					<Select
						autoWidth={true}
						value={value}
						inputProps={{
							id: qid,
							name: qid,
						}}
						onChange={this.handleChangeSelect(qid)}
						classes={{
							selectMenu: this.props.classes.whiteSpace,
						}}
					>
						<MenuItem value={0}>
							<em>{i18n.t('QuestionnaireWizard_0003')}</em>
						</MenuItem>
						{options.map((option, i) => (
							<MenuItem
								key={i}
								value={option.replyOrder}
								className={
									this.props.classes.whiteSpaceMenuItem
								}
							>
								{option.replyText}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</form>
		);
	}

	/**
	 * ラジオボタンコンポーネント
	 * @param questionnaire 質問情報
	 */
	protected questionnaireRadio(questionnaire: Actions.IQuestionnaire) {
		const options = questionnaire.options as Actions.IOption[];
		const qid = questionnaire.questionnaireID;
		const value = (this.state.answers[qid] as number) || -1;
		return (
			<form autoComplete="off">
				<FormControl
					component="fieldset"
					className={this.props.classes.width}
				>
					<RadioGroup
						name={questionnaire.questionnaireID}
						onChange={this.handleChangeRadio(qid)}
						value={value.toString()}
					>
						{options.map((option, j) => {
							const replyOrder = option.replyOrder
								? option.replyOrder.toString()
								: '';
							return (
								<FormControlLabel
									key={j}
									value={replyOrder}
									control={<Radio />}
									label={option.replyText}
								/>
							);
						})}
					</RadioGroup>
				</FormControl>
			</form>
		);
	}

	/**
	 * チェックボックスコンポーネント
	 * @param questionnaire 質問情報
	 */
	protected questionnaireCheck(questionnaire: Actions.IQuestionnaire) {
		const options = questionnaire.options as Actions.IOption[];
		const qid = questionnaire.questionnaireID;
		const values = (this.state.answers[qid] as number[]) || [];
		return (
			<FormControl
				component="fieldset"
				className={this.props.classes.width}
			>
				<FormGroup>
					{options.map((option, i) => {
						const replyOrder = option.replyOrder
							? option.replyOrder.toString()
							: '';
						return (
							<FormControlLabel
								key={i}
								value={replyOrder}
								control={
									<Checkbox
										checked={
											values.find(
												a => a === option.replyOrder
											)
												? true
												: false
										}
									/>
								}
								label={option.replyText}
								onChange={this.handleChangeCheck(qid)}
							/>
						);
					})}
				</FormGroup>
			</FormControl>
		);
	}

	/**
	 * テキストコンポーネント
	 * @param questionnaire 質問情報
	 */
	protected questionnaireText(questionnaire: Actions.IQuestionnaire) {
		const { classes } = this.props;
		const qid = questionnaire.questionnaireID;
		const value = (this.state.answers[qid] as string) || '';
		return (
			<form noValidate={true} autoComplete="off">
				<TextField
					className={classes.textArea}
					id={qid}
					rows={3}
					margin="normal"
					multiline={true}
					onChange={this.handleChangeText(qid)}
					value={value}
				/>
			</form>
		);
	}

	/**
	 * 提出ボタン、一時保存ボタン
	 */
	protected Buttons: React.FC = () => {
		return (
			<Grid container={true} justify="center" spacing={3}>
				<Grid item={true}>
					<Fab
						color="primary"
						variant="extended"
						size="large"
						onClick={this.handleReport}
						disabled={this.state.disableReportButton}
					>
						{i18n.t('QuestionnaireWizard_0004')}
					</Fab>
				</Grid>
				<Dialog
					open={this.state.openReportConfirm}
					onClose={this.handleCloseConfirmReport}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('QuestionnaireWizard_0005')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.props.assessmentFlg
								? i18n.t('QuestionnaireWizard_0006')
								: i18n.t('QuestionnaireWizard_0007')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleStartReport}
							color="primary"
						>
							{i18n.t('QuestionnaireWizard_0016')}
						</Button>
						<Button onClick={this.handleCloseConfirmReport}>
							{i18n.t('QuestionnaireWizard_0008')}
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={this.state.openReportResult}
					onClose={this.handleCloseReportResult}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('QuestionnaireWizard_0009')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.props.assessmentFlg
								? i18n.t('QuestionnaireWizard_0010')
								: i18n.t('QuestionnaireWizard_0011')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseReportResult}
							color="primary"
						>
							{i18n.t('QuestionnaireWizard_0017')}
						</Button>
					</DialogActions>
				</Dialog>
				{((this.props.assessmentFlg &&
					this.props.displayTmpSaveBtn &&
					this.props.flg === 2) ||
					(!this.props.assessmentFlg &&
						this.props.displayTmpSaveBtn &&
						this.state.previewDisplayTmpSaveBtn &&
						this.props.flg === 0)) && (
					<Grid item={true}>
						<Fab
							color="default"
							variant="extended"
							size="large"
							onClick={this.handleSaveQuestionnaire}
							disabled={this.state.disableReportButton}
						>
							{i18n.t('QuestionnaireWizard_0012')}
						</Fab>
						<Snackbar
							anchorOrigin={{
								horizontal: 'left',
								vertical: 'bottom',
							}}
							open={this.state.saveResultSnackbar}
							autoHideDuration={6000}
							onClose={this.handleSaveResultSnackbarClose}
							ContentProps={{
								'aria-describedby': 'message-id',
							}}
							message={
								<span id="message-id">
									{i18n.t('QuestionnaireWizard_0013')}
								</span>
							}
						/>
					</Grid>
				)}
			</Grid>
		);
	};

	/**
	 * 前に戻るハンドラ
	 */
	protected handlePrev = () => {
		if (this.props.accessFlg === 1 && this.preBtnDisabled) {
			this.props.handlePrev();
			return;
		}
		const { selectedBlock, selectedQuestionnaire } = this.state;
		if (selectedQuestionnaire > 0) {
			this.setState({ selectedQuestionnaire: selectedQuestionnaire - 1 });
			return;
		}
		const prevBlock = selectedBlock - 1;
		this.setState({
			selectedBlock: prevBlock,
			selectedQuestionnaire:
				this.props.blocks[prevBlock].questionnaires.length - 1,
		});
	};

	/**
	 * 次へハンドラ
	 */
	protected handleNext = () => {
		if (this.props.accessFlg === 1 && this.nextBtnDisabled) {
			this.props.handleNext();
			return;
		}
		const { selectedBlock, selectedQuestionnaire } = this.state;
		const block = this.props.blocks[selectedBlock];
		if (selectedQuestionnaire < block.questionnaires.length - 1) {
			this.setState({ selectedQuestionnaire: selectedQuestionnaire + 1 });
			return;
		}
		const nextBlock = selectedBlock + 1;
		this.setState({
			selectedBlock: nextBlock,
			selectedQuestionnaire: 0,
		});
	};

	/**
	 * 提出ボタン押下ハンドラ
	 */
	protected handleReport = () => {
		this.setState({
			openReportConfirm: true,
		});
	};

	/**
	 * 提出確認ダイアログクローズハンドラ
	 */
	protected handleCloseConfirmReport = () => {
		this.setState({
			openReportConfirm: false,
		});
	};

	/**
	 * 提出開始
	 */
	protected handleStartReport = () => {
		this.setState({
			disableReportButton: true,
			openReportConfirm: false,
		});

		const updatedBlocks = this.makeUpdatedBlocks();
		if (
			this.props.unAnsweredCheck(this.props.mustAnswerFlg, updatedBlocks)
		) {
			this.setState({ disableReportButton: false });
			return;
		}

		const messages: IMessage[] = [];
		for (const ansTest of updatedBlocks) {
			const blockName = ansTest.blockName;
			for (const a1 of ansTest.questionnaires) {
				const questionnaireNo = a1.questionnaireNo;
				if (
					a1.questionnaireType !== undefined &&
					a1.questionnaireType !== null &&
					a1.questionnaireType === '4'
				) {
					if (
						a1.options !== null &&
						a1.options !== undefined &&
						a1.options[0].replyText !== null &&
						a1.options[0].replyText !== undefined &&
						a1.options[0].replyText.length > 2000
					) {
						const mess =
							blockName +
							'　' +
							questionnaireNo.substr(
								0,
								questionnaireNo.length - 1
							) +
							i18n.t('QuestionnaireWizard_0014');
						const message: IMessage = {
							content: 'CHK_E_0004',
							replacements: [mess, '2000'],
						};
						messages.push(message);
						// 表示
						if (messages.length !== 0) {
							this.setState({
								disableReportButton: false,
								messages,
								openErrorMessageDialog: true,
							});
							return;
						}
					}
				}
			}
		}
		if (this.props.preview) {
			this.setState({
				disableReportButton: false,
				openReportResult: true,
			});
			return;
		}
		this.props
			.updateQuestionnaireWizard(this.props.token, {
				blocks: updatedBlocks,
				careerID: this.props.careerID,
				classID: this.props.classID,
				enqueteID: this.props.id,
				isPreview: this.props.preview,
				renewalDate: this.props.renewalDate,
				startTime: this.props.startTime,
				userId: this.props.userAttr.userId,
			})
			.then(result => {
				this.setState({
					disableReportButton: false,
					openReportResult: true,
				});

				if (!this.props.assessmentFlg) {
					// 進捗率更新
					this.props.fetchELearningProgress(this.props.token, {
						careerID: this.props.careerID,
						classID: this.props.classID,
						isPreview: this.props.preview,
						userId: this.props.userAttr.userId,
					});
				}
			});
	};

	/**
	 * 提出確認ダイアログのクローズハンドラ
	 */
	protected handleCloseReportResult = () => {
		const portalFlg = localStorage.getItem('portalFlg');
		if (portalFlg === '0') {
			funcClose();
			return;
		}
		// this.props.onReported();
		this.setState({
			openReportResult: false,
		});
		if (this.props.preview) {
			this.setState({
				previewDisplayTmpSaveBtn: false,
			});
			return;
		}
		if (!this.props.assessmentFlg) {
			this.props.fetchELearningTree(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				userAttr: this.props.userAttr,
			});
		}
		// スキル情報画面に遷移
		if (this.props.assessmentFlg) {
			const to = Routes.getPath(Screens.PERSONAL_SKILL);
			this.props.pushHistory(to);
		} else {
			// アンケート一覧画面に遷移
			if (this.props.onlyQuestionFlg) {
				let to = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
				to = to.replace(/\/:career_id/, `/${this.props.careerID}`);
				to = to.replace(/\/:class_id/, `/${this.props.classID}`);
				this.props.pushHistory(to);
			}
		}
	};

	/**
	 * 一時保存ボタン押下ハンドラ
	 */
	protected handleSaveQuestionnaire = () => {
		this.setState({
			disableReportButton: true,
		});

		const updatedBlocks = this.makeUpdatedBlocks();
		const messages: IMessage[] = [];
		for (const ansTest of updatedBlocks) {
			const blockName = ansTest.blockName;
			for (const a1 of ansTest.questionnaires) {
				const questionnaireNo = a1.questionnaireNo;
				if (
					a1.questionnaireType !== undefined &&
					a1.questionnaireType !== null &&
					a1.questionnaireType === '4'
				) {
					if (
						a1.options !== null &&
						a1.options !== undefined &&
						a1.options[0].replyText !== null &&
						a1.options[0].replyText !== undefined &&
						a1.options[0].replyText.length > 2000
					) {
						const mess =
							blockName +
							'　' +
							questionnaireNo.substr(
								0,
								questionnaireNo.length - 1
							) +
							i18n.t('QuestionnaireWizard_0015');
						const message: IMessage = {
							content: 'CHK_E_0004',
							replacements: [mess, '2000'],
						};
						messages.push(message);
						// 表示
						if (messages.length !== 0) {
							this.setState({
								disableReportButton: false,
								messages,
								openErrorMessageDialog: true,
							});
							return;
						}
					}
				}
			}
		}
		if (this.props.preview) {
			this.setState({
				disableReportButton: false,
				saveResultSnackbar: true,
			});
			return;
		}
		this.props
			.saveQuestionnaireWizard(this.props.token, {
				blocks: updatedBlocks,
				careerID: this.props.careerID,
				classID: this.props.classID,
				enqueteID: this.props.id,
				isPreview: this.props.preview,
				renewalDate: this.props.renewalDate,
				startTime: this.props.startTime,
				userId: this.props.userAttr.userId,
			})
			.then(result => {
				this.setState({
					disableReportButton: false,
					saveResultSnackbar: true,
				});
			});
	};

	/**
	 * 一時保存後のSnackbarクローズハンドラ
	 */
	protected handleSaveResultSnackbarClose = (event: any, reason: any) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ saveResultSnackbar: false });
	};

	/**
	 * 選択肢変更ハンドラ
	 */
	protected handleChangeSelect = (questionnaireID: string) => (
		event: React.ChangeEvent<HTMLSelectElement>
	) => {
		const target = event.target as HTMLSelectElement;
		this.state.answers[questionnaireID] = target.value;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * ラジオボタン変更ハンドラ
	 */
	protected handleChangeRadio = (questionnaireID: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		this.state.answers[questionnaireID] = target.value;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * チェックボックスクリック時ハンドラ
	 */
	protected handleChangeCheck = (questionnaireID: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const value = +target.value;
		if (this.state.answers[questionnaireID]) {
			// すでに回答リストがある場合はそこに追加か削除
			const answers = this.state.answers[questionnaireID] as number[];
			const newAnswers = answers.filter(a => a !== value);
			if (target.checked) {
				newAnswers.push(value);
			}
			this.state.answers[questionnaireID] = newAnswers;
		} else {
			// 回答リストがない場合は新しく作成
			this.state.answers[questionnaireID] = [value];
		}
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * テキスト変更ハンドラ
	 */
	protected handleChangeText = (questionnaireID: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		this.state.answers[questionnaireID] = target.value;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * 提出、一時保存用に回答の入力を反映したblocksを作成する
	 */
	protected makeUpdatedBlocks() {
		const updatedBlocks: Actions.IQuestionnaireBlock[] = [];
		for (const fromB of this.props.blocks) {
			const toB: Actions.IQuestionnaireBlock = {
				blockID: fromB.blockID,
				blockName: fromB.blockName,
				blockNo: fromB.blockNo,
				questionnaires: fromB.questionnaires.map(fromQ => {
					const answer = this.state.answers[fromQ.questionnaireID];
					const toQ: Actions.IQuestionnaire = {
						mustFlg: fromQ.mustFlg,
						options: null,
						questionnaireID: fromQ.questionnaireID,
						questionnaireNo: fromQ.questionnaireNo,
						questionnaireText: fromQ.questionnaireText,
						questionnaireType: fromQ.questionnaireType,
					};
					switch (fromQ.questionnaireType) {
						case Actions.QuestionnaireType.SELECT:
						case Actions.QuestionnaireType.RADIO_BUTTON:
							toQ.selectedReply = answer as number;
							break;
						case Actions.QuestionnaireType.CHECK_BOX:
							toQ.options = [];
							for (const fromO of fromQ.options as Actions.IOption[]) {
								const answers = answer as number[];
								const selected = answers.find(
									a => a === fromO.replyOrder
								)
									? true
									: false;
								toQ.options.push({
									replyOrder: fromO.replyOrder,
									replyText: fromO.replyText,
									selected,
								});
							}
							break;
						case Actions.QuestionnaireType.TEXT_AREA:
							const replyText = (answer as string) || '';
							toQ.options = [{ replyText }];
							break;
					}
					return toQ;
				}),
			};
			updatedBlocks.push(toB);
		}
		return updatedBlocks;
	}

	/**
	 * アンケート情報取得
	 */
	protected fetch() {
		this.props.fetchQuestionnaireWizard(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			enqueteID: this.props.id,
			isPreview: this.props.preview,
			userId: this.props.userAttr.userId,
		});
	}
}

const mapStateToProps = (state: IRootState) => ({
	blocks: state.questionnaire.blocks,
	displayTmpSaveBtn: state.questionnaire.displayTmpSaveBtn,
	enqueteName: state.questionnaire.enqueteName,
	mustAnswerFlg: state.questionnaire.mustAnswerFlg,
	periodJudgment: state.questionnaire.periodJudgment,
	renewalDate: state.questionnaire.renewalDate,
	respondentCategoryFlg: state.questionnaire.respondentCategoryFlg,
	scoreItemsRegisterFlag: state.questionnaire.scoreItemsRegisterFlag,
	selectedQuestionnaire: state.questionnaire.selectedQuestionnaire,
	startTime: state.questionnaire.startTime,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearQuestionnaireParams: () =>
		dispatch(Actions.clearQuestionnaireParams({})),
	fetchELearningProgress: (
		token: string,
		arg: IFetchELearningProgressParam
	) => {
		const s = ELearningScenarioFactory.createFetchELearningProgress(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchQuestionnaireWizard: (
		token: string,
		arg: IFetchQuestionnaireParam
	) => {
		const s = ScenarioFactory.createFetchQuestionnaireWizard(
			dispatch,
			token
		);
		s.run(arg);
	},
	saveQuestionnaireWizard: (token: string, arg: ISaveQuestionnaireParam) => {
		const s = ScenarioFactory.createSaveQuestionnaireWizard(
			dispatch,
			token
		);
		return s.run(arg);
	},
	updateQuestionnaireWizard: (
		token: string,
		arg: IUpdateQuestionnaireParam
	) => {
		const s = ScenarioFactory.createUpdateQuestionnaireWizard(
			dispatch,
			token
		);
		return s.run(arg);
	},

	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ELearningScenarioFactory.createFetchELearningTree(
			dispatch,
			token
		);
		s.run(arg);
	},

	doFetchCareerDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCareerDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	pushHistory: (path: string) => dispatch(push(path)),
});

export interface IQuestionnaireWizardProps extends IQuestionnaireProps {
	assessmentFlg: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IQuestionnaireWizardProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuestionnaireWizard);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuestionnaireWizard.tsx